/* global globalThis */
// eslint-disable-next-line unicode-bom

import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, message, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from "react-redux";
import { Link, useHistory, withRouter } from 'react-router-dom';
import { T } from '../../components/Translations';
import { ApiUrl, AppPages, Defines, UserRoles } from '../../project/Defines';
import { Project } from '../../project/Project';
import { dispatchCustomEvent, EVENT_NAME, useCustomEvent } from '../../project/utilities';
import { hideLoader, showLoader } from '../../Shared/Loader';
import { changeCulture, clearListStates, closeAllPopups, login, openPopup, storageChange, enableServiceContractChange } from '../../store/actions';
import { Ajax } from '../Ajax';
import { PopupTypes } from '../Popup';

import moment from 'moment';

const NETWORKCODE = "networkCode";

const LanguageChange = (props) => {

  let { culture } = props;
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const ref = useRef(false);
  const languageCode = ['es', 'pt', 'en', 'fr', 'it'];

  useEffect(() => {
    ref.current = true;

    let language = i18n.language;
    if (language.indexOf("-") !== -1) {
      language = language.split('-')[0];
    }
    dispatch(changeCulture(culture || language));
    return () => { ref.current = false; };

  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    i18n.changeLanguage(culture);
  }, [i18n, culture]);

  const changeLanguage = lng => {
    if (ref.current) {
      /* //i18n.changeLanguage(lng); */
      dispatch(changeCulture(lng));
    }
  };

  const menu = (
    <div className="list_menu ant-dropdown-menu">
      <ul>
        {languageCode.map((lng, index) => (
          <React.Fragment key={lng}>
            <li 
              style={{ justifyContent: "center" }}
              className={`${culture === lng ? "selected" : ""}`}
              onClick={() => changeLanguage(lng)}
            >
              <Tooltip placement="right" title={t(`languages.${lng}`)}>
                <text>{lng}</text>
              </Tooltip>
            </li>
            {(languageCode.length - 1 > index) && <li
              className="separator"></li>}
          </ React.Fragment>
        ))}
      </ul>
    </div>
  );

  return (
    <Dropdown
      trigger={['click']}
      overlay={menu}
      placement="topRight"
    >
      <div command="languageMenu" effect="material" className="button adaptive">
        <icon data-type="new" data-adaptive="mobile">language</icon>
        <text>{culture?.toUpperCase()}</text>
      </div>
    </Dropdown>
  );

  // return <>

  //   <Tooltip placement="bottom" title={t('languages.es')}>
  //     <div effect="material" className={culture === 'es' ? "button primary" : "button"} onClick={() => changeLanguage('es')}
  //     ><text>es</text></div>
  //   </Tooltip>
  //   <Tooltip placement="bottom" title={t('languages.pt')}>
  //     <div effect="material" className={culture === 'pt' ? "button primary" : "button"} onClick={() => changeLanguage('pt')}
  //     ><text>pt</text></div>
  //   </Tooltip>
  //   <Tooltip placement="bottom" title={t('languages.en')}>
  //     <div effect="material" className={culture === 'en' ? "button primary" : "button"} onClick={() => changeLanguage('en')}
  //     ><text>en</text></div>
  //   </Tooltip>
  //   <Tooltip placement="bottom" title={t('languages.fr')}>
  //     <div effect="material" className={culture === 'fr' ? "button primary" : "button"} onClick={() => changeLanguage('fr')}
  //     ><text>fr</text></div>
  //   </Tooltip>
  //   <Tooltip placement="bottom" title={t('languages.it')}>
  //     <div effect="material" className={culture === 'it' ? "button primary" : "button"} onClick={() => changeLanguage('it')}
  //     ><text>it</text></div>
  //   </Tooltip>

  // </>;
};

LanguageChange.propTypes = {
    culture: PropTypes.string
};

/**
 * represents the control for selecting current interface language */
const LanguageChangeComponent = connect(state => ({
  culture: state.culture
}), null)(LanguageChange);

export const menuItems = [
  { to: AppPages.Planning, text: <T>text.planning</T>, icon: "calendar_today" },
  { to: AppPages.ServiceCalls, text: <T>text.service_calls</T>, detail: AppPages.ServiceCallsDetails, icon: "call" },
  {
    to: AppPages.ServiceCallsUnassigned, text: <T>text.service_calls_unassigned_declined</T>,
    render: (unassigned, selected) => <>
    <wrap>
      <icon data-type="new" data-adaptive="mobile">call_log</icon>
      <span>
        <text ><T>text.service_calls_unassigned_declined</T></text>
        {unassigned > 0 && <div command="notification" effect="material" className="button special micro" data-tip="" style={{ backgroundColor: selected ? '#fff' : 'var(--main-color)', color: selected ? '#000' : '#fff' }}
        >{unassigned}</div>}
      </span>
    </wrap>


    </>, icon: "call_log"
  },
  {
    text: <T>text.documents</T>, subMenu: [
      { to: AppPages.Fees, text: <T>text.fees</T>, selected: false },
      { to: AppPages.SpareParts, text: <T>text.spare_parts</T>, selected: false },
      { to: AppPages.DPC, text: <T>text.dpc</T>, selected: false }
    ], icon: "article"
  },
  { to: AppPages.InvoiceGeneration, text: <T>text.invoice_generation</T>, icon: "download" },
  {
    to: AppPages.ServiceContract, text: <T>text.service_contract</T>, detail: AppPages.ServiceContractDetails, icon: "contract"
  }
];

/**
 * The layout component specifies the site layout, top menu based on login state and active states of top menu items
 * @param {object} props  { isLoggedIn, popups, culture, role, etc.}
 */

function Menu(props) {
  const { /*storageChange,*/ enableServiceContractChange, role, closeAllPopups, login, clearListStates, userData, culture, openPopup, isLoggedIn, enableServiceContract, dataMaintenance, networkCode, oldToken, userToken } = props;
  const [unassigned, setUnassigned] = useState(0);
  const isDispatcher = role === UserRoles.DISPATCHER;
  const location = globalThis.location.pathname.toLowerCase();
  const history = useHistory();
  const [closeMaintenance, setCloseMaintenance] = useState(true);

  let logoutUrl = props.userData?.logoutUrl ? props.userData?.logoutUrl : Project.getPageUrl(AppPages.Logout);

  useEffect(() => {
    isDispatcher && updateUnassigned();
  }, [location, isLoggedIn]);//eslint-disable-line react-hooks/exhaustive-deps

  const updateUnassigned = useCallback(() => {
    isDispatcher && Ajax.get({
      url: ApiUrl.GetUnassignedServicaCallsCount,
      data: {},
      success: function (response) {
        if (!response?.HasError) {
          setUnassigned(response);
        }
      }
    });
  }, [isDispatcher]);
  useCustomEvent(EVENT_NAME.CALL_ASSIGNED, updateUnassigned);

  const openConnectAs = () => {
    openPopup({
      windowKey: 'wndConnnectAs',
      title: <T>text.connect_as</T>,
      type: PopupTypes.ConnectAsPicker,
      // className: PopupClasses.Large,
      fullScreen: false
    });
  };
  const revertConnectAs = () => {
    const connectAsLoader = 'CONNECT_AS_LOADER';
    showLoader(connectAsLoader);
    Ajax.post({
      url: ApiUrl.Logout,
      data: { oldToken, reverse: true },
      success: function (response) {

        if (response && ((response.status && response.status === 200) || response.redirectUrl)) {
          const redirectUrl = response.redirectUrl;
          closeAllPopups();
          clearListStates();
          login({
            userToken: response.userToken || userToken,
            userName: response.userName,
            culture: response.culture,
            role: response.role,
            enableServiceContract: response.enableServiceContract,
            networkCode: response.networkCode,
            sessionId: response.sessionId,
            userData: {
              userName: response.userName,
              networks: response.networks,
              canCreateCall: response.canCreateCall
            }
          });
          if (redirectUrl && redirectUrl !== Project.getPageUrl(AppPages.Login)) {
            history.push(redirectUrl);
          }
          else {
            history.push(Project.getPageUrl(AppPages.Home));
          }
        } else if (response) {
          message.error(response.title || <T>message.error_api</T>);
        } else {
          message.error(<T>message.error_api</T>);
        }
        hideLoader(connectAsLoader);
      },
      error: function () {
        message.error(<T>message.error_api</T>);
        hideLoader(connectAsLoader);
      }
    });
  };

  const updateNetwork = useCallback((item) => {
    localStorage.setItem(NETWORKCODE, JSON.stringify(item.code))
    enableServiceContractChange({
      enableServiceContract: item.enableServiceContract
    });
    dispatchCustomEvent(EVENT_NAME.SERVICE_CALL_LIST_UPDATE);
    globalThis.location.reload();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  let userMenu =
  <div className="list_menu ant-dropdown-menu">
    <ul>
      {isDispatcher && userData?.networks?.length > 0 && (
        <>
          {userData.networks.map((item, index) => {
            const isActive = item.code === networkCode;
            return (
              <React.Fragment key={item.networkName + index}>
                <li
                  className={`dropdown-item ${isActive ? "selected" : ""}`}
                  onClick={() => updateNetwork(item)}
                >
                  <icon></icon>
                  <text>{item.networkName}</text>
                </li>
                {userData.networks.length - 1 > index && <li className="separator"></li>}
              </React.Fragment>
            )
          })}
          <li className="separator"></li>
        </>
      )}

      {/* Connect as / revert */}
      {role === UserRoles.DISPATCHER && (
        <li onClick={openConnectAs}>
          <icon></icon>
          <text><T>text.connect_as</T></text>
        </li>
      )}

      {userData && (
        <>
          {userData.internalConnectAs ? (
            <li onClick={revertConnectAs}>
              <icon></icon>
              <text><T>text.back_as_dispatcher</T></text>
            </li>
          ) : (
            userData.portalName && userData.portalUrl && (
              <li>
                <a href={userData.portalUrl}>
                  <icon></icon>
                  <text><T>{userData.portalName}</T></text>
                </a>
              </li>
            )
          )}
        </>
      )}

      <li className="separator"></li>

      {/* Version */}
      <li className="disabled">
        <icon>info</icon>
        <text><T>text.version</T></text>
        <separator vertical=""></separator>
        <text><b>{process.env.REACT_APP_VERSION}</b></text>
      </li>

      <li className="separator"></li>

      {/* Logout */}
      <li>
        <a href={logoutUrl}>
          <icon></icon>
          <text><T>text.sign_out</T></text>
        </a>
      </li>
    </ul>
  </div>;


  let selectedItem = null;

  const onColseMaintenanceMessage = () => {
    setCloseMaintenance(false);
  }

  const currentDateTimeSecond = Date.parse(new Date()) / 1000;
  const currentDate = Math.floor(currentDateTimeSecond / (60 * 60 * 24));

  const dateTimeSecondStart = dataMaintenance?.date_start && Date.parse(moment.utc(dataMaintenance?.date_start).local().format()) / 1000;
  const dateStart = dataMaintenance?.date_start && Math.floor(dateTimeSecondStart / (60 * 60 * 24));
  // const correctDateStart = dataMaintenance?.date_start && moment.utc(dataMaintenance?.date_start).local().format(Defines.Format.MomentDate);
  // const correctDateEnd = dataMaintenance?.date_end && moment.utc(dataMaintenance?.date_end).local().format(Defines.Format.MomentDate);
  const correctDateTimeStart = dataMaintenance?.date_start && moment.utc(dataMaintenance?.date_start).local().format(Defines.Format.MomentDateTime);
  const correctDateTimeEnd = dataMaintenance?.date_end && moment.utc(dataMaintenance?.date_end).local().format(Defines.Format.MomentDateTime);

  const getDaysDiff = (currentDate, dateStart) => {
    return dateStart - currentDate;
  }

  return <>
    <toolbar id="mainHeader" className="main_header">


      <nav launcher=""
        //data-adaptive="desktop"
        id="launcher">
        <ul>
          {
            // eslint-disable-next-line
            menuItems.filter(item => item.to != AppPages.ServiceContract || // console.log(item) || // (networkCode == "YGNITA" && item?.subMenu && item.subMenu.filter((i) => i.to != AppPages.DPC)) ||
              enableServiceContract).map((item, i) => {

                const url = Project.getPageUrl((item.to && Project.hasRoleAccess(role, item.to)) ? item.to : item.subMenu && [...item.subMenu].sort(sm => sm.isDefault ? -1 : 1).find(sub => Project.hasRoleAccess(role, sub.to))?.to) || "";

                const selected = url && (
                  url.toLowerCase() === location 
                  || (item.detail && Project.hasRoleAccess(role, item.to) && location.startsWith(Project.getPageUrl(item.detail) + "/"))
                  || (item.subMenu?.some(sub => Project.hasRoleAccess(role, sub.to) && (location.startsWith(Project.getPageUrl(sub.to)) || (sub.detail && location.startsWith(Project.getPageUrl(sub.detail))))))
                  || (item.pages?.some(p => Project.hasRoleAccess(role, p) && Project.getPageUrl(p) === location))
                );

                if (selected) {
                  document.onkeydown = (e) => {
                    const keyF1 = 'F1';

                    if (e.key === keyF1) {
                      if (!item.help.default) {
                        e.preventDefault();
                        const urlPDF = `/help/${(item.help.fr && culture === "fr") ? item.help.fr : item.help.en}`;
                        globalThis.open(urlPDF, "_blank");
                      }
                    }
                  };
                  selectedItem = {
                    url,
                    subMenu: item.subMenu || []
                  };
                }

                if (!url) {
                  return <div key={i} style={{ display: 'none' }}
                  ></div >;
                }

                return <li key={i}
                  className={selected ? "selected" : ""} >
                  <Link to={url} onClick={closeAllPopups} >
                    {
                    (item.render?.(unassigned, selected)) ||
                      <>
                        <wrap>
                          <icon data-type="new" data-adaptive="mobile">{item.icon}</icon>
                          <text>{item.text} </text>
                        </wrap>
                      </>
                    }
                  </Link>
                </li>;

              })
          }
        </ul>

      </nav>


      {
        props.isLoggedIn && !Project.skipHeader(location) && userData &&
        <>
          <div className='wrap'>
            <LanguageChangeComponent />
            <separator vertical=""
            ></separator>

            <Dropdown
              className=""
              trigger={['click']}
              overlay={userMenu}
              placement="topRight"
            >
              <div command="userMenu" effect="material" className="button adaptive">
                <icon data-tip={userData?.userName}>user</icon>
                <text>{userData?.networks?.find(item => item.code === networkCode)?.userName || userData?.userName}</text>
              </div>
            </Dropdown>
          </div>
        </>
      }

    </toolbar>

    {dataMaintenance?.active && closeMaintenance && isLoggedIn && !Project.skipHeader(location) && userData && getDaysDiff(currentDate, dateStart) <= 15 && currentDateTimeSecond <= dateTimeSecondStart && <div className="alert_contianer"
    >
      <alert warning="warning"
      >
        <icon>info</icon>
        {/* <text marquee="marquee"><span><T>text.maintenance_title</T></span></text> */}
        <text marquee="marquee"
        ><span><T args={[`${correctDateTimeStart} - ${correctDateTimeEnd}`]}>text.maintenance_message</T></span></text>
        {/** {culture === 'es' && <text marquee="marquee"><b>{dataMaintenance?.messages?.es && <T>text.maintenance_message</T>}</b></text>}
        {culture === 'pt' && <text marquee="marquee"><b>{dataMaintenance?.messages?.pt && <T>text.maintenance_message</T>}</b></text>}
        {culture === 'en' && <text marquee="marquee"><b>{dataMaintenance?.messages?.en && <T>text.maintenance_message</T>}</b></text>}
        {culture === 'fr' && <text marquee="marquee"><b>{dataMaintenance?.messages?.fr && <T>text.maintenance_message</T>}</b></text>}
        {culture === 'it' && <text marquee="marquee"><b>{dataMaintenance?.messages?.it && <T>text.maintenance_message</T>}</b></text>} */}
        <action>
          {/* <div className="button accent"><text>Verify</text></div>
            <separator vertical="vertical"></separator> */}
          <div className="button mini close" onClick={() => onColseMaintenanceMessage()}
          ><icon>close</icon></div>
        </action>
      </alert>
    </div>
    }
    {selectedItem?.subMenu?.length && selectedItem.subMenu.some(sub => Project.hasRoleAccess(role, sub.to)) ?
      <toolbar
      //className="main_header"
      >
        <nav launcher=""
        >
          <ul>
            {// eslint-disable-next-line
              selectedItem.subMenu.filter(sub => (networkCode == "YGNITA" ? sub.to !== AppPages.DPC : sub)).map((item, i) => {
                const url = (Project.hasRoleAccess(role, item.to) && Project.getPageUrl(item.to)) || "";
                return url ? <li key={i} className={url.toLowerCase() === location || (item.detail && location.startsWith(Project.getPageUrl(item.detail) + "/")) ? "selected" : ""}
                >
                  <Link to={url} onClick={closeAllPopups} ><text>{item.text}</text></Link>
                </li> : <div key={i} style={{ display: 'none' }}
                ></div >;
              })}
          </ul>
        </nav>
      </toolbar> : <></>}
  </>;
}

Menu.propTypes = {
    enableServiceContractChange: PropTypes.func.isRequired,
    role: PropTypes.string,
    closeAllPopups: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    clearListStates: PropTypes.func.isRequired,
    userData: PropTypes.object,
    culture: PropTypes.string,
    openPopup: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool,
    enableServiceContract: PropTypes.bool.isRequired,
    dataMaintenance: PropTypes.object,
    networkCode: PropTypes.string,
    oldToken: PropTypes.string,
    userToken: PropTypes.string
};

export default connect(state => ({
  role: state.role,
  culture: state.culture,
  userToken: state.userToken,
  userData: state.userData,
  isLoggedIn: state.isLoggedIn,
  networkCode: state.networkCode,
  enableServiceContract: state.enableServiceContract,
  dataMaintenance: state.dataMaintenance,
  oldToken: state.oldToken,
  portalUrl: state.portalUrl
}),
  dispatch => ({
    dispatch,
    openPopup: (props) => dispatch(openPopup(props)),
    clearListStates: () => dispatch(clearListStates()),
    closeAllPopups: () => dispatch(closeAllPopups()),
    login: (props) => dispatch(login(props)),
    storageChange: (props) => dispatch(storageChange(props)),
    enableServiceContractChange: (props) => dispatch(enableServiceContractChange(props))
  }))(withRouter(Menu));